const { inject, observer } = require('mobx-react');
const { withRouter } = require('react-router-dom');
const React = require('react');

const { QueryRoute } = require('bernie-core');
const { withLocalization } = require('bernie-l10n');

// Components
const { VirtualAgentControl } = require('@shared-ui/customer-virtual-agent-control');
const { CustomerNotificationLocation } = require('@shared-ui/customer-notifications');
const { Experiment, ExperimentControl, ExperimentVariant } = require('@shared-ui/experiment-context');
const { IntersectionTracker } = require('@shared-ui/clickstream-analytics-context');
const { RefProviderRoot, RefTarget } = require('@shared-ui/ref-context');

const { PropertyListingProvider } = require('stores/contexts/propertyListing/property-listing-provider');
const { RefProvider } = require('src/common/stores/contexts/ref-provider');

const { InfositePageName } = require('constants/pages');
const { RfrrPageNamespace } = require('constants/analytics');

/* eslint-disable max-lines */
/* eslint-disable complexity */
const { ActivityRecommendationsWrapper } = require('components/infosite/activity-recommendations');
const { CustomerNotifications } = require('components/common/customer-notifications');
const { ErrorLink } = require('components/infosite/error-link');
const { LoadingPlaceholder } = require('components/infosite/rooms-and-rates/loading-placeholder');
const { MainRegion } = require('components/layout/pages/main-region');
const { MasterPageWrapper } = require('components/layout/pages/master-page-wrapper');
const { MesoFooter } = require('components/meso/meso-footer');
const { MesoSideRail } = require('components/meso/meso-side-rail');
const { MessagingCard } = require('components/common/messaging-card/messaging-card');
const { MultiItem } = require('components/multi-item');
const { NavigationRegion } = require('components/layout/pages/navigation-region');
const { PDPTemplates } = require('components/templates/templates');
const { PropertyGallery } = require('components/infosite/property-details/property-gallery');
const { PropertyHighlightSection } = require('components/infosite/property-highlight-section');
const { PropertyInformation } = require('components/infosite/property-information');
const { PropertySummaryBackLinkWrapper } = require('components/infosite/property-summary-backlink-wrapper');
const { RewardsEducationDialog } = require('components/common/rewards-education-dialog');
const { roomsAndRatesLoadable } = require('components/infosite/rooms-and-rates/loadable');
const { SharedUiBookByPhoneWrapper } = require('components/infosite/shared-ui/details/book-by-phone-wrapper');
const { SharedUiFaqWrapper } = require('src/common/components/infosite/shared-ui/details/faq-wrapper');
const { SharedUiNavigationBarWrapper } = require('components/infosite/shared-ui/details/navigation-bar-wrapper');
const { SharedUiPropertyPillFiltersWrapper } = require('components/infosite/shared-ui/shared-ui-property-pill-filters');
const { SharedUiPropertyReviewsWrapper } = require('components/infosite/shared-ui/reviews/shared-ui-property-reviews-wrapper');
const { SharedUiSpaceDetailsExperiment } = require('components/infosite/shared-ui/experiments/space-details-experiment');
const { SharedUiSummaryWrapper } = require('src/common/components/infosite/shared-ui/details/summary-wrapper');
const { SharedUiTripSummaryWrapper } = require('components/infosite/shared-ui/offers/trip-summary-wrapper');
const { SharedUiWhatsAroundWrapper } = require('components/infosite/shared-ui/details/whats-around-wrapper');
const { SideRailRegion } = require('components/layout/pages/side-rail-region');
const { SimilarHotels } = require('components/infosite/similar-hotels/similar-hotels');
const { SingleOfferTemplate } = require('components/infosite/template-components/single-offer-template');
const { WelcomeNotification } = require('components/common/welcome-notification');

@withLocalization
@withRouter
@inject(
  'advertising',
  'analytics',
  'context',
  'currentHotel',
  'experiment',
  'multiItem',
  'page',
  'routeStore',
  'searchResults',
  'uiPage',
  'virtualAgentControlStore',
  'pageLayout'
)
@observer
class Infosite extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      forceHistoryPush: false,
    };

    this.forceHistoryPushOnGoBack = this.forceHistoryPushOnGoBack.bind(this);
    this.goBack = this.goBack.bind(this);
    this.markUsable = this.markUsable.bind(this);
    this.pageShowEvents = this.pageShowEvents.bind(this);

    if (
      this.props.multiItem &&
      this.props.multiItem.isMixMatchEnabled &&
      typeof this.props.multiItem.getOrCreateCart === 'function' &&
      !this.props.multiItem.isPackageShoppingPath()
    ) {
      this.props.multiItem.getOrCreateCart(this.props.context);
    }
    this.props.advertising.trigger('page.Hotels.Infosite.Information');
  }

  componentDidMount() {
    const { currentHotel } = this.props;

    if (currentHotel) {
      const { pageUsableMarked, usable } = currentHotel;

      this.markUsable(pageUsableMarked, usable);
    }

    // Mobile safari uses the back-forward cache meaning when a user clicks back
    // from CKO to HIS the spinner is still showing and the components do not re render,
    // need to manually dismiss this from a previously attached event.
    window.addEventListener('pageshow', this.pageShowEvents);
    window.scrollTo(0, 0);
  }

  shouldComponentUpdate(nextProps) {
    const { pageUsableMarked, usable } = nextProps.currentHotel;

    this.markUsable(pageUsableMarked, usable);

    return true;
  }

  componentDidUpdate(prevProps) {
    const { routeStore, uiPage, location, history } = this.props;

    if (routeStore.queryParams.scrollPosition) {
      uiPage.setFocusItem(routeStore.queryParams.scrollPosition);
      const query = routeStore.mergeQueryString(routeStore.search, null, key => !key.startsWith('scrollPosition'));
      const queryCombinerFunction = (prevQuery, newQuery) => newQuery;
      routeStore.updateSearch(query, undefined, true, queryCombinerFunction);
    } else if (location && prevProps.location && location.pathname !== prevProps.location.pathname && history.action === 'PUSH') {
      window.scrollTo(0, 0);
    }
  }

  markUsable(pageUsableMarked, usable) {
    const { analytics, currentHotel } = this.props;

    if (usable && !pageUsableMarked) {
      analytics.markPageUsable();

      currentHotel.pageUsableMarked = true;
    }
  }

  componentWillUnmount() {
    window.removeEventListener('pageshow', this.pageShowEvents);
  }

  pageShowEvents() {
    this.props.uiPage.hideProgressIndicator();
  }

  forceHistoryPushOnGoBack() {
    this.props.searchResults.clearDefaultRequestFields();
    this.setState({
      forceHistoryPush: true,
    });
  }

  goBack(e) {
    const { analytics, routeStore, history, currentHotel, l10n } = this.props;
    const partnerPropertySearchLink = currentHotel.offers?.partnerPropertySearchLink;
    const backToPartnerSite = partnerPropertySearchLink?.link.uri.value;
    const propertySearchLink = currentHotel.offers?.propertySearchLink;
    const backToHsrUrl = propertySearchLink?.link.uri.relativePath;

    if (analytics) {
      analytics.trackEvent('.BackToSearch', l10n.formatText('hotels.infosite.backToSearchResults.linkText'), null);
    }

    if (this.state.forceHistoryPush || routeStore.navigationDepth <= 0) {
      if (partnerPropertySearchLink) {
        window.location.href = backToPartnerSite;
      } else {
        history.push(backToHsrUrl);
      }
    } else {
      e.preventDefault();
      routeStore.goBack();
    }
  }

  render() {
    const {
      analytics,
      currentHotel,
      page,
      route,
      routeStore,
      context,
      multiItem,
      virtualAgentControlStore,
      experiment,
      uiPage,
      pageLayout,
    } = this.props;

    const { searchCriteria, hotel, isFailure, offers, property, similarHotels, similarHotelsDateless } = currentHotel || {};

    const { specialMessageCard } = hotel || {};
    const serpMetadata = offers && offers.serpMetadata;
    const legalDisclaimer = offers && offers.legalDisclaimer;
    const destination = searchCriteria && searchCriteria.destination;
    const isDateless = searchCriteria && searchCriteria.isDateless;
    const rewardsEducation = offers && offers.rewardsDialogContent && offers.rewardsDialogContent.rewardsEducation;
    const propertyHighlightSection = offers?.propertyHighlightSection;
    const pageName = page?.pageName || InfositePageName.SA;

    const priceOnSerpTrafficTest =
      // eslint-disable-next-line camelcase
      context.viewModelResponse?.flexContext?.experimentContext?.experiments?.Schema_PriceOnSERP_TrafficTest;

    const masterProps = {
      className: 'infosite',
      dataStid: 'infosite-page-container',
      pageUsable: true,
      route,
      searchCriteria,
    };

    let priceRange;

    if (priceOnSerpTrafficTest === 1) {
      priceRange = serpMetadata?.priceRange?.value;
    } else if (priceOnSerpTrafficTest === 2) {
      priceRange = serpMetadata?.priceRating?.value;
    }

    const { templateName } = pageLayout;

    return (
      <RefProvider>
        <RefProviderRoot>
          <MasterPageWrapper {...masterProps}>
            <MainRegion key="main-region" className="main-region infosite__main" structure={hotel?.structure}>
              {isFailure && <ErrorLink />}
              <PropertyListingProvider propertyListing={property}>
                <div className="infosite__content infosite__content--details">
                  <PropertySummaryBackLinkWrapper />
                  {templateName === PDPTemplates.CONVENTIONAL_LODGING && (
                    <>
                      <PropertyGallery priceRange={priceRange} />
                      <NavigationRegion className="navigation-bar-region constrained">
                        <SharedUiNavigationBarWrapper showReserveBtn={false} showNightlyPrice={false} showReserveBtnOnLoad={true} />
                      </NavigationRegion>
                      <SharedUiSummaryWrapper />

                      <PropertyHighlightSection model={propertyHighlightSection} />
                      <MessagingCard
                        tag="div"
                        testId="mod-signup-signin-banner"
                        model={offers && offers.messagingCardModel && offers.messagingCardModel.model}
                      />
                      <MessagingCard tag="div" testId="special-message-banner" model={specialMessageCard && specialMessageCard.model} />
                      <MessagingCard
                        tag="div"
                        testId="free-lx-banner"
                        model={offers && offers.freeLxMessagingCard && offers.freeLxMessagingCard.model}
                      />

                      {offers?.spacesViewModel && (
                        <IntersectionTracker
                          intersectionOptions={{ threshold: 1 }}
                          trackOnce={false}
                          referrerId={`${RfrrPageNamespace.Infosite}.intersection.spacedetails.tracker`}
                          linkName="The Space Details has been viewed"
                          className="space-layout-analytics-wrapper all-y-margin-three"
                        >
                          <SharedUiSpaceDetailsExperiment spacesViewModel={offers.spacesViewModel} />
                        </IntersectionTracker>
                      )}

                      <SharedUiTripSummaryWrapper />

                      <div data-stid="rooms-rates">
                        {React.createElement(roomsAndRatesLoadable.codeSplit, {
                          forceHistoryPushOnGoBack: this.forceHistoryPushOnGoBack,
                          className: 'rooms-rates',
                          RefTarget,
                          BookByPhone: SharedUiBookByPhoneWrapper,
                          loadingState: <LoadingPlaceholder />,
                        })}
                      </div>

                      <SimilarHotels similarHotels={similarHotels} />

                      <SharedUiWhatsAroundWrapper data-stid="about-area" />

                      <SimilarHotels similarHotels={similarHotelsDateless} isDatelessPdp={isDateless} />
                      <ActivityRecommendationsWrapper uiPage={uiPage} />

                      <PropertyInformation data-stid="about-property" />

                      <SharedUiFaqWrapper isDateless={isDateless} />
                      <SharedUiPropertyReviewsWrapper currentHotel={currentHotel} routeStore={routeStore} context={context} />
                      <Experiment name="LP_PDP_culdesac_display_filter_pills_to_HSR">
                        <ExperimentControl />
                        <ExperimentVariant bucket={1} />
                        <ExperimentVariant bucket={2}>
                          <SharedUiPropertyPillFiltersWrapper />
                        </ExperimentVariant>
                      </Experiment>
                    </>
                  )}
                  {templateName === PDPTemplates.SINGLE_UNIT_VR && <SingleOfferTemplate />}
                </div>
              </PropertyListingProvider>

              <CustomerNotifications location={CustomerNotificationLocation.FOOTER} />
              <MesoFooter pageName={pageName} destination={destination} isDateless={isDateless} />

              {legalDisclaimer?.content && (
                <div className="all-y-padding-six">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: legalDisclaimer?.content
                        .filter(content => content.markupType === 'HTML')
                        .map(content => content.text)
                        .join('<br/><br/>'),
                    }}
                  />
                </div>
              )}
              <QueryRoute query={{ pwaDialog: 'rewardsEducation' }}>
                <RewardsEducationDialog rewardsEducation={rewardsEducation} />
              </QueryRoute>
              <WelcomeNotification />
              {multiItem && !multiItem.isPackageShoppingPath() && <MultiItem pageName={pageName} />}
              {virtualAgentControlStore.shouldInjectChatbot(context, page, experiment) && (
                <VirtualAgentControl
                  applicationName="shopping-pwa"
                  pageName={pageName}
                  clientOverrides={{
                    subscribedEvents: [virtualAgentControlStore.VAC_WIDGET_OPENED_EVENT, virtualAgentControlStore.VAC_WIDGET_CLOSED_EVENT],
                    eventHandler: event => virtualAgentControlStore.eventHandler(analytics, event),
                  }}
                />
              )}
            </MainRegion>
            <SideRailRegion key="side-rail-region">
              <MesoSideRail pageName={pageName} />
            </SideRailRegion>
          </MasterPageWrapper>
        </RefProviderRoot>
      </RefProvider>
    );
  }
}

module.exports = Infosite;
